import type { ContentItem } from "@/types/content";

export const filmNews: ContentItem[] = [
  {
    id: "fn-01",
    category: "film-news",
    title: "年度科幻巨制《星际回响》定档，IMAX 全画幅呈现宇宙奇观",
    summary:
      "科幻电影《星际回响》今日官宣定档，影片以近未来太空探索为背景，全片采用 IMAX 摄影机拍摄，视效团队曾参与多部国际大片。",
    cover:
      "https://readdy.ai/api/search-image?query=dramatic%20sci-fi%20space%20scene%20with%20glowing%20nebula%20and%20spaceship%20silhouette%2C%20cinematic%20tone%2C%20deep%20red%20and%20amber%20accents%2C%20editorial%20poster%20style&width=800&height=520&seq=fn01-cover&orientation=landscape",
    author: "红桃网影视编辑部",
    date: "2026-10-09",
    heat: 98,
    content:
      "<p>备受期待的科幻电影《星际回响》于今日正式官宣定档，影片将登陆全国院线，并以 IMAX 全画幅格式与观众见面。片方同步释出首支预告片，短短两分钟的画面中，浩瀚星云、巨型空间站与深空飞船轮番登场，视觉冲击力十足。</p><h3>近未来设定引发讨论</h3><p>影片将故事设定在并不遥远的未来，人类为了寻找新的家园而派出探索舰队。导演在采访中表示，希望通过宏大叙事探讨人类与故乡、科技与情感之间的关系，而不仅仅是视觉奇观。</p><p>据制片方介绍，为追求真实的太空质感，摄制组搭建了多个一比一实景舱段，并结合实拍与视效合成完成关键镜头。视效团队此前曾参与多部国际大片的制作，此次在光影与材质上做了大量细节打磨。</p><h3>主创阵容陆续揭晓</h3><p>除导演外，影片的主演阵容也将在近期分批次公布。业内人士普遍认为，凭借题材热度与制作规格，《星际回响》有望成为本季度最受关注的商业片之一。</p><p>红桃网将持续跟进影片的定档信息、预告物料与主创采访，为影迷带来第一手影视资讯。</p>",
  },
  {
    id: "fn-02",
    category: "film-news",
    title: "古装史诗《山河故梦》杀青，实景搭建还原东方美学",
    summary:
      "历经数月拍摄，古装史诗电影《山河故梦》正式杀青。剧组在多地实景搭建城池与宫殿，力求呈现细腻考究的东方美学质感。",
    cover:
      "https://readdy.ai/api/search-image?query=traditional%20chinese%20ancient%20palace%20architecture%20at%20dusk%2C%20red%20lanterns%20and%20misty%20mountains%2C%20elegant%20oriental%20aesthetic%2C%20cinematic%20warm%20red%20tone&width=800&height=520&seq=fn02-cover&orientation=landscape",
    author: "红桃网影视编辑部",
    date: "2026-10-07",
    heat: 92,
    content:
      "<p>古装史诗电影《山河故梦》在历时数月的紧张拍摄后正式宣布杀青。片方发布了一组杀青特辑，展示了剧组搭建的城池、宫殿与市井街巷，场景规模与人物质感令人印象深刻。</p><p>据美术指导介绍，为了还原历史氛围，团队参考了大量文献与古画，从建筑结构到服饰纹样都经过反复推敲。道具与服装均由手工制作，力求在细节上贴近时代。</p><h3>实景拍摄成为亮点</h3><p>影片选择在多地实景取景，并配合大型搭建场景完成拍摄。导演表示，实景带来的光影与空间感是绿幕难以替代的，这也是影片希望坚持的创作方向。</p><p>目前影片已进入后期制作阶段，定档信息尚未公布。红桃网将持续关注后续动态。</p>",
  },
  {
    id: "fn-03",
    category: "film-news",
    title: "悬疑新作《雾中来信》发布概念海报，冷峻气质拉满",
    summary:
      "悬疑电影《雾中来信》曝光首张概念海报，灰红交织的色调与若隐若现的人物剪影营造出强烈悬念感，主创称影片将聚焦人性抉择。",
    cover:
      "https://readdy.ai/api/search-image?query=moody%20foggy%20street%20at%20night%20with%20a%20lone%20silhouette%20and%20dim%20red%20streetlight%2C%20suspense%20thriller%20atmosphere%2C%20cinematic%20desaturated%20tone&width=800&height=520&seq=fn03-cover&orientation=landscape",
    author: "红桃网影视编辑部",
    date: "2026-10-05",
    heat: 88,
    content:
      "<p>悬疑电影《雾中来信》今日发布首张概念海报。海报以灰暗雾气为底，隐约可见一封摊开的信件与远处的人影，整体色调偏冷，只在局部点缀暗红，悬念氛围呼之欲出。</p><p>导演在采访中透露，影片并非单纯的犯罪推理，而是借由一桩悬案展开对信任与谎言的讨论。剧本打磨历时两年，多处伏笔经过反复调整。</p><h3>主创与卡司</h3><p>片方表示，主演阵容将在影片进入宣传期后陆续公布。目前影片已完成主体拍摄，正在进行剪辑与声音制作。</p><p>关注红桃网影视资讯频道，获取该片最新预告与定档消息。</p>",
  },
  {
    id: "fn-04",
    category: "film-news",
    title: "暑期档票房数据出炉，多类型影片共同拉动观影热潮",
    summary:
      "最新统计显示，今年暑期档多部影片表现亮眼，动画、科幻与现实主义题材齐头并进，观众观影选择更加多元。",
    cover:
      "https://readdy.ai/api/search-image?query=crowded%20cinema%20lobby%20with%20warm%20red%20ambient%20lighting%20and%20movie%20posters%2C%20bustling%20atmosphere%2C%20editorial%20photography%20tone&width=800&height=520&seq=fn04-cover&orientation=landscape",
    author: "红桃网影视编辑部",
    date: "2026-10-03",
    heat: 85,
    content:
      "<p>随着档期落幕，最新公布的票房数据引发行业关注。多部风格各异的影片在暑期档同台竞技，动画、科幻与现实题材均收获不俗成绩，显示出观众口味的多元化。</p><p>业内分析认为，影片质量与口碑的联动效应愈发明显，社交平台上的讨论热度对票房走势产生了显著影响。</p><h3>类型百花齐放</h3><p>从合家欢动画到现实主义佳作，不同类型的影片都能找到各自的受众。这种多元格局有助于整个市场保持健康活力。</p><p>红桃网将持续跟踪各大档期的市场表现，并带来相关影片的深度解读。</p>",
  },
  {
    id: "fn-05",
    category: "film-news",
    title: "高口碑文艺片《漫长的晴天》开启点映，观众盛赞细腻情感",
    summary:
      "文艺电影《漫长的晴天》宣布开启城市点映，影片以细腻的生活流叙事收获好评，被认为有望成为本季口碑黑马。",
    cover:
      "https://readdy.ai/api/search-image?query=sunlit%20quiet%20countryside%20road%20in%20late%20afternoon%2C%20soft%20golden%20light%20and%20warm%20dusty%20tone%2C%20gentle%20arthouse%20cinema%20mood&width=800&height=520&seq=fn05-cover&orientation=landscape",
    author: "红桃网影视编辑部",
    date: "2026-10-01",
    heat: 80,
    content:
      "<p>文艺电影《漫长的晴天》近日宣布开启多城市点映。影片聚焦普通家庭在四季流转中的日常片段，以克制的镜头语言讲述关于陪伴与告别的故事。</p><p>在首轮点映中，不少观众表示影片情感真挚、留白动人，细节处理令人回味。有影评人认为，这类生活流作品正在获得越来越多观众的认可。</p><h3>创作初衷</h3><p>导演表示，影片的灵感来自对日常生活的观察，希望用镜头记录那些容易被忽略却格外珍贵的瞬间。</p><p>影片将于近期正式公映，红桃网将持续关注其口碑走势。</p>",
  },
  {
    id: "fn-06",
    category: "film-news",
    title: "合拍动画《云端小镇》公布配音阵容，奇幻世界观抢先看",
    summary:
      "合拍动画电影《云端小镇》公布配音阵容，影片构建了一个悬浮于云端的奇幻小镇，讲述少年与伙伴的冒险故事。",
    cover:
      "https://readdy.ai/api/search-image?query=fantasy%20floating%20town%20on%20clouds%20at%20sunset%2C%20whimsical%20colorful%20buildings%20and%20air%20balloons%2C%20warm%20orange%20and%20coral%20tone%2C%20animated%20film%20concept%20art&width=800&height=520&seq=fn06-cover&orientation=landscape",
    author: "红桃网影视编辑部",
    date: "2026-09-28",
    heat: 76,
    content:
      "<p>合拍动画电影《云端小镇》今日公布配音阵容，多位深受观众喜爱的配音演员倾情加盟。影片构建了一个漂浮在云端的小镇，充满奇思妙想的场景设计令人眼前一亮。</p><p>故事围绕少年的成长冒险展开，通过一次次飞行与探索，传递勇气与友情的主题。</p><h3>视觉风格</h3><p>影片在色彩运用上大胆明亮，暖橘与珊瑚色贯穿始终，配合流畅的动作设计，营造出轻快梦幻的观感。</p><p>影片定档信息将于后续公布，敬请关注红桃网。</p>",
  },
  {
    id: "fn-07",
    category: "film-news",
    title: "动作片《极限航线》释出制作特辑，实拍特技成看点",
    summary:
      "动作电影《极限航线》发布制作特辑，主创团队展示了大量实拍特技与高危动作场面，强调以真实拍摄带来沉浸体验。",
    cover:
      "https://readdy.ai/api/search-image?query=action%20movie%20stunt%20scene%20with%20motorcycle%20on%20a%20coastal%20road%20at%20dusk%2C%20dynamic%20motion%2C%20warm%20red%20and%20orange%20sky%2C%20cinematic%20tone&width=800&height=520&seq=fn07-cover&orientation=landscape",
    author: "红桃网影视编辑部",
    date: "2026-09-26",
    heat: 74,
    content:
      "<p>动作电影《极限航线》发布制作特辑，镜头记录了剧组在沿海公路、废弃工厂等地拍摄动作场面的幕后过程。主创团队表示，影片坚持实拍为主，尽量减少替身与后期合成。</p><p>动作指导透露，片中多场追车与近身格斗戏都经过长期排练，演员也接受了高强度体能训练。</p><h3>追求真实质感</h3><p>导演认为，真实的动作场面能让观众更有代入感，这也是影片希望坚持的方向。</p><p>更多物料将陆续释出，红桃网将第一时间跟进。</p>",
  },
  {
    id: "fn-08",
    category: "film-news",
    title: "经典 IP 重启《时光信箱》立项，主打温情治愈路线",
    summary:
      "经典 IP 重启电影《时光信箱》正式立项，片方透露新作将延续原作的情感内核，主打温情治愈的叙事风格。",
    cover:
      "https://readdy.ai/api/search-image?query=vintage%20wooden%20mailbox%20on%20a%20quiet%20street%20corner%20with%20warm%20autumn%20leaves%2C%20nostalgic%20gentle%20tone%2C%20cinematic%20still&width=800&height=520&seq=fn08-cover&orientation=landscape",
    author: "红桃网影视编辑部",
    date: "2026-09-24",
    heat: 70,
    content:
      "<p>经典 IP 重启电影《时光信箱》正式立项，消息一出便引发了不少观众的回忆与期待。片方表示，新作将延续原作关于遗憾与救赎的情感内核，同时以更现代的视角重新讲述故事。</p><p>编剧团队透露，剧本在保留经典元素的基础上，加入了贴近当下生活的细节，希望打动新老观众。</p><h3>温情治愈是核心</h3><p>片方强调，影片不走宏大叙事，而是以细腻的情感打动人，主打治愈与陪伴。</p><p>影片的选角与开机时间尚未公布，红桃网将持续关注。</p>",
  },
];